import Box from "@mui/material/Box";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import calendarAlternateIcon from "../../assets/icon-calendar-alternate.svg";

/** Figma `Calendar-Alternate` — 20×20, used as MUI DatePicker open-picker icon. */
export function DatePickerCalendarAlternateIcon({ sx, className }: SvgIconProps) {
  return (
    <Box
      component="img"
      src={calendarAlternateIcon}
      alt=""
      aria-hidden
      className={className}
      sx={{
        width: 20,
        height: 20,
        display: "block",
        objectFit: "contain",
        pointerEvents: "none",
        ...sx,
      }}
    />
  );
}
